import { TaxServiceInterface } from '@services/requests/taxService/interface';

import { TaxService } from './TaxService';

// Фабрика сервиса
export const taxService: { (): TaxServiceInterface } = () => new TaxService();
